import { Stack, Typography } from '@mui/material'

import { RepairOrderExpanded, VehicleEntry } from '../../sdk'

export const DviTitle = ({
  vehicle,
  repairOrder
}: {
  vehicle: VehicleEntry | undefined
  repairOrder: RepairOrderExpanded | undefined
}) => {
  return (
    <Stack alignItems="center" mt={2} spacing={1}>
      <Typography variant="h2">
        {vehicle
          ? `${vehicle?.info?.year} ${vehicle?.info?.make?.name} ${vehicle?.info?.model?.name}`
          : 'Vehicle Loading...'}
      </Typography>
      <Typography variant="h6">
        {repairOrder ? `RO#${repairOrder?.entry?.localId}` : 'RO# Loading...'}
      </Typography>
    </Stack>
  )
}
